import { render } from "./CatalogCreate.vue?vue&type=template&id=4e7b4920"
import script from "./CatalogCreate.vue?vue&type=script&lang=js"
export * from "./CatalogCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__